module.exports = __webpack_public_path__ + "static/img/9.d63f8c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/9.png
// module id = /hWL
// module chunks = 0